module.exports = __webpack_public_path__ + "img/grey_schedule.2361b8ad.svg";